import { component } from "picoapp";
import { isCartOpen } from "../../utilities";

export const cartToggle = component((node: HTMLButtonElement) => {
  if (isCartOpen()) return;
  let controller: AbortController;

  node.addEventListener("click", function () {
    if (!("maestro" in window)) return;
    if (controller) {
      controller.abort();
    }
    controller = new AbortController();
    const signal = controller.signal;
    fetch("/cart.js", { signal })
      .then(async (response) => {
        if (response.ok) {
          const cartData = await response.json();
          (window as any).maestro.fireTrackEvent("cartViewed", {
            $cart: cartData,
          });
        } else {
          console.log("Error fetching cart data");
        }
      })
      .catch((e) => {
        console.log("Error fetching cart data", e);
      });
  });
});
